/**
 * Base styling on the Zoom web component that can only be overridden via it's style attribute.
 *
 * Firefox/Brave fix: Zoom uses canvas in its shadow DOM on these browsers.
 * Slotted content backgrounds paint over the canvas due to shadow DOM stacking.
 * We override canvas z-index so video renders above cell backgrounds.
 */
export function observeShadowRoot(element: HTMLElement | null) {
  if (!element) return;

  const shadowRoot = element.shadowRoot;
  if (!shadowRoot) return;

  // watch for new canvas elements added to shadow DOM
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        if (addedNode instanceof HTMLCanvasElement) {
          // directly modify the element's style
          addedNode.style.zIndex = '1';
        }
      }
    }
  });

  observer.observe(shadowRoot, { childList: true, subtree: true });

  return observer;
}
